<template>
    <v-card>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="bids"
                hide-actions
                item-key="id"
                :loading="loading">
                <template #items="props">
                    <td class="text-xs-right name"><v-icon>{{ type === 'tel' ? 'phone' : 'assignment' }}</v-icon></td>
                    <td class="text-xs-right">{{ props.item.amount | num }}</td>
                    <td class="text-xs-right">{{ props.item.auction_number }}</td>
                    <td class="text-xs-center">{{ props.item.code }}</td>
                    <td class="name">{{ props.item.name }}</td>
                    <td class="text-xs-center">{{ props.item.is_or ? 'X' : '' }}</td>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'pad-lot-bid',
    props: {
        item: { type: Object },
        type: { type: String }
    },
    data: () => ({
        loading: false,
        headers: [
            { text: '', value: 'type', sortable: false, align: 'center' },
            { text: 'Montant', value: 'amount', sortable: false, align: 'right' },
            { text: 'N°', value: 'auction_number', sortable: false, align: 'right' },
            { text: 'Code', value: 'code', sortable: false },
            { text: 'Acheteur', value: 'name', sortable: false },
            { text: 'OU', value: 'is_or', sortable: false, align: 'center' }
        ],
        bids: []
    }),
    mounted() {
        this.load()
    },
    methods: {
        load() {
            // comme on a déjà quelques infos de bids, on les mets en attendant
            // le reste
            this.bids = this.type === 'tel' ? this.item.bidsPhone : this.item.bidsNormal
            this.loading = true
            return this.$api.get(`/apad/lots/${this.item.id}/bids/${this.type}`)
                .then(res => {
                    if (this.type === 'tel') {
                        res.data.sort((a, b) => a.auction_number - b.auction_number)
                    }
                    this.bids = res.data
                })
                .finally(() => this.loading = false)
        }
    }
}
</script>

<style lang="stylus" scoped>
.name
    width: 100%;
    white-space: nowrap;

</style>
